import { useEffect, useState } from 'react';
import { esperarSplashTerminado, yaSeFueElSplash } from '../utils/arranque';

/**
 * Entrada del home al quitarse el splash, como en las apps nativas: todo ya
 * está cargado detrás (no hay esqueletos de mentira ni esperas extra), pero en
 * vez de aparecer quieto de golpe, el contenido entra en cascada en ~0.5 s:
 * el encabezado de la promo, las pestañas, las tarjetas deslizándose desde la
 * derecha y luego categorías y menú. El contenedor verde ya está ahí: solo se
 * mueve lo de adentro.
 *
 * Solo se anima si el home se montó con el splash encima. Si se llega al home
 * después (regresando del carrito, por ejemplo), aparece normal.
 *
 * Uso: const entrada = useEntradaHome();
 *      <div {...entrada(120)} />            sube y aparece, 120 ms después
 *      <div {...entrada(200, 'lado')} />    entra desde la derecha
 */
// Lo que tarda la cascada completa (último retraso + la animación) con margen.
const DURACION_TOTAL_MS = 1500;

export function useEntradaHome() {
  const [animar, setAnimar] = useState(() => !yaSeFueElSplash());
  const [visible, setVisible] = useState(() => yaSeFueElSplash());

  useEffect(() => {
    if (!animar) return;
    let vivo = true;
    let fin;
    esperarSplashTerminado().then(() => {
      if (!vivo) return;
      setVisible(true);
      // Pasada la entrada se quitan las clases: lo que se monte después (las
      // tarjetas de otra pestaña, por ejemplo) aparece normal, sin repetirla.
      fin = setTimeout(() => { if (vivo) setAnimar(false); }, DURACION_TOTAL_MS);
    });
    return () => { vivo = false; clearTimeout(fin); };
  }, [animar]);

  return (retraso = 0, tipo = 'arriba', clase = '') => {
    if (!animar) return { className: clase };
    return {
      // Escondido mientras el splash lo tapa; al quitarse, la animación
      // (entrada-arriba / entrada-lado en index.css) lo trae con su retraso.
      className: `${clase} ${visible ? `entrada-${tipo}` : 'opacity-0'}`,
      style: { '--retraso': `${retraso}ms` },
    };
  };
}
